const classes = {
  heading: 'text-secondary',
  paragraph: 'pr-4 text-sm text-pretty font-medium text-secondary-readable',
} as const;

export default classes;
